import { render, staticRenderFns } from "./FrundModal.vue?vue&type=template&id=357c1395&"
import script from "./FrundModal.vue?vue&type=script&lang=js&"
export * from "./FrundModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports